export default __webpack_public_path__ + "static/media/group.11d2d5c3.svg";